import { LogOboPayload } from 'models';
import { AnyAction } from 'redux';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { OnBehalfTypes } from 'redux/actions/onBehalfAction';
import { RootState } from 'redux/store';
import AuditServices, { LogRequestPayload } from 'services/auditServices';
import BaseAction from '../actions/baseAction';

export type TypeLog = 
  | 'OBO'
  | 'DELEGATION';

interface LogData extends LogOboPayload {
  user_id: string;
  impersonate_user_id: string;
  typeLog: TypeLog;
};

function generateLogPayload(data: LogData): LogRequestPayload {
  const { user_id, impersonate_user_id, action, type, detail, typeLog = 'OBO'} = data;

  let message = '';

  switch (action) {
    case 'START':
      message = `[${user_id}] started act on behalf of [${impersonate_user_id}]`;
      break;
    case 'VIEW':
      message = `[${user_id}] viewed ${type} ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'CREATE':
      message = `[${user_id}] submitted a ${type?.toUpperCase()} request with ticket ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'ADD_GROUP':
      message = `[${user_id}] added [${impersonate_user_id}] into group ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'RESOLVE':
      message = `[${user_id}] resolved ticket ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'REOPEN':
      message = `[${user_id}] reopened ticket ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'CANCEL':
      message = `[${user_id}] cancelled ticket ${detail} on behalf of [${impersonate_user_id}]`;
      break;
    case 'END':
      message = `[${user_id}] ended act on behalf of [${impersonate_user_id}]`;
      break;
    case "DEFINE_DELEGATION":
        message = `[${user_id}] delegated to [${impersonate_user_id}] from ${detail?.start_date} to ${detail?.end_date}`;
        break;
    case "UPDATE_DELEGATION":
      message = `[${user_id}] updated delegatee to [${impersonate_user_id}] from ${detail?.start_date} to ${detail?.end_date}`;
      break;
    case "ENABLE_DELEGATION":
      message = `[${user_id}] enabled delegation to [${impersonate_user_id}]`;
      break;
    case "DISABLE_DELEGATION":
      message = `[${user_id}] disabled delegation to [${impersonate_user_id}]`;
      break;
    case "APPROVAL":
      message = `[${user_id}] approved ticket ${detail?.RITMNumber} for [${detail?.approver}]`;
      break;
    case "REJECT":
      message = `[${user_id}] rejected ticket ${detail?.RITMNumber} for [${detail?.approver}]`;  
      break;   
    case "INITIATE_CHAT":
      message = `[${user_id}] created report broken device ticket ${detail} for [${impersonate_user_id}]`;  
      break;
    default:
      break;
  }

  return {
    user_id,
    impersonate_user_id,
    message,
    type: typeLog,
  };
}

export function* uptimeAuditLog(action: AnyAction) {
  try {
    const state: RootState = yield select();
    const { baseReducer, onBehalfReducer } = state;
    const { currentUser } = baseReducer;
    const { isOnBehalf, userOnBehalf } = onBehalfReducer;

    const isOBO = isOnBehalf && userOnBehalf;

    if(action?.payload?.typeLog){
      const payload = generateLogPayload({
         ...action.payload,
      });
      yield call(AuditServices.logRequest, payload);
    }
    else{
      if (!currentUser || !isOBO) return;
      const payload = generateLogPayload({
        user_id: currentUser.uid,
        impersonate_user_id: userOnBehalf.uid,
        ...action.payload,
      });
      yield call(AuditServices.logRequest, payload);
    }
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `LOG_ON_BEHALF_OF ${error}`,
      }),
    );
  }
}

export const watchOnBehalf = [
  takeLatest(OnBehalfTypes.UPTIME_AUDIT_LOG, uptimeAuditLog),
];
